import { green, red } from '@mui/material/colors'
import { Typography } from '@mui/material'

interface DeltaProps {
  value: number
  reference: number
  // 'up-is-bad' (e.g. total open events, overdue): increase shown red.
  // 'up-is-good' (e.g. SLA compliance): increase shown green.
  polarity: 'up-is-bad' | 'up-is-good'
}

function Delta({ value, reference, polarity }: DeltaProps) {
  const diff = value - reference
  if (diff === 0) {
    return (
      <Typography component="span" variant="caption" color="text.secondary">
        =
      </Typography>
    )
  }
  const up = diff > 0
  const isBadDirection = polarity === 'up-is-bad' ? up : !up
  const color = isBadDirection ? red[700] : green[700]
  const arrow = up ? '↑' : '↓'
  const abs = Math.abs(diff)
  const pct = reference === 0 ? null : Math.round((diff / reference) * 100)
  return (
    <Typography component="span" variant="caption" sx={{ color, fontWeight: 600 }}>
      {arrow}
      {abs.toFixed(reference === Math.floor(reference) && value === Math.floor(value) ? 0 : 1)}
      {pct !== null && ` (${pct > 0 ? '+' : ''}${pct}%)`}
    </Typography>
  )
}

export default Delta
